import React from 'react';
import PropTypes from 'prop-types';
import { UpgradeBottomSlides, WxLaunchApp, PageBottomBrand } from 'ThreeTerminal_mobile_dynamic';
import { h5PageCount } from 'ThreeTerminal_utils';
import { callApp, getSchemeLink, getWebAppLink } from '@ifeng-fe/callapp';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';

class BottomSlide extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
        config: PropTypes.object,
        wxLaunch: PropTypes.object,
        pageBottomPic: PropTypes.object,
        classV: PropTypes.array,
        ad: PropTypes.object,
    };

    activityHandle = (isSendCount = true, isJumpQQlink = false, isCall = true) => {
        const { content, pageBottomPic } = this.props;
        const schemeUrl = (pageBottomPic?.articleShare?.jumpMode === 2 && pageBottomPic?.articleShare?.url) || '';
        let kind = '';

        if (content.type === 'short') {
            kind = 'shortdoc';
        } else if (content.type === 'slide') {
            kind = 'pic';
        } else {
            kind = 'article';
        }
        h5PageCount([
            {
                behavior: 'action',
                type: 'hot_dopen',
                other: {
                    ref: `ucms_${content.base62Id}`,
                    url: encodeURIComponent(location.href),
                    kind,
                },
            },
        ]);

        if (isCall) {
            if (schemeUrl) {
                callApp({
                    docType: 'custom',
                    pid: schemeUrl,
                    download: 'http://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1473191849934',
                    downloadAd: 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=8821',
                    isJumpQQlink,
                });
            } else {
                location.href = pageBottomPic?.articleShare?.url;
            }
        }
    };

    componentDidMount() {
        const { content, pageBottomPic } = this.props;
        const activityImage = pageBottomPic?.articleShare?.imageUrl;
        let kind = '';

        if (content.type === 'short') {
            kind = 'shortdoc';
        } else if (content.type === 'slide') {
            kind = 'pic';
        } else {
            kind = 'article';
        }

        if (activityImage) {
            h5PageCount([
                {
                    behavior: 'pageinfo',
                    type: 'hot_dopen',
                    other: [`ucms_${content.base62Id}`, kind],
                },
            ]);
        }
    }

    isOpenOperateHandle = () => {
        const { pageBottomPic, classV } = this.props;
        const isOpen = pageBottomPic?.articleShare?.isOpen;
        const hasChannelRange = pageBottomPic?.articleShare?.hasChannelRange;
        const channelRange = pageBottomPic?.articleShare?.channelRange;

        if (isOpen) {
            if (hasChannelRange) {
                let flag = false;

                channelRange.split(',').forEach((item) => {
                    if (!flag && classV.join(',').includes(item)) {
                        flag = true;
                    }
                });

                return flag;
            }

            return true;
        }

        return false;
    };

    clickBottomHandle = () => {
        window.isClickPageBottom = true;
        try {
            if (window.BJ_REPORT) {
                window.BJ_REPORT.report(new Error(), false, 53);
            }
        } catch (err) {
            console.error(err);
        }
        // 判断是否是安卓环境
        if (!navigator.userAgent.toLocaleLowerCase().includes('android')) {
            let secondNum = 0;
            const headTimer = setInterval(() => {
                if (secondNum > 3) {
                    clearInterval(headTimer);
                }
                if (window.pageIshareHidden) {
                    clearInterval(headTimer);
                    try {
                        if (window.BJ_REPORT) {
                            window.BJ_REPORT.report(new Error(), false, 54);
                        }
                    } catch (err) {
                        console.error(err);
                    }
                }

                secondNum++;
            }, 1000);
        }
    };

    render() {
        /**
         * 组件分发数据
         */
        const { content, config, wxLaunch, pageBottomPic, ad } = this.props;
        const downloads = content.isVideoShare
            ? {}
            : {
                  download: 'https://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1453822808118',
                  downloadAd: 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=8796',
              };

        const wxLaunchType = wxLaunch.wxLaunchType;
        const wxLaunchSwitch = wxLaunch.wxLaunchSwitch;
        const slidesConfig = {
            isVideoShare: content.isVideoShare,
            apiConfig: {
                type: 'doc',
                from: 'share_relate_foot_doc',
                n: 4,
                // proid: 'ifeng_share',
                id: `ucms_${content.base62Id}`,
                // title: content.title,
                apiUrl: 'nine',
            },
            isLogoPic: true,
            sendSucessLog: true,
            insertSlideArr: [
                {
                    clickCount: {
                        behavior: 'action',
                        type: 'downopen',
                        other: {
                            ref: `ucms_${content.base62Id}`,
                            to: true,
                            kind: 'article',
                            url: encodeURIComponent(location.href),
                            plat: 'napp',
                        },
                    },
                    downloads,
                    kind: 'share52202',
                    wxLaunchType,
                    wxLaunchSwitch,
                },
                {
                    clickCount: {
                        behavior: 'action',
                        type: 'downopen',
                        other: {
                            ref: `ucms_${content.base62Id}`,
                            kind: 'article',
                            url: encodeURIComponent(location.href),
                            plat: 'napp',
                        },
                    },
                    downloads,
                    kind: 'share52202',
                    wxLaunchType,
                    wxLaunchSwitch,
                },
                {
                    clickCount: {
                        behavior: 'action',
                        type: 'downopen',
                        other: {
                            ref: `ucms_${content.base62Id}`,
                            kind: 'article',
                            url: encodeURIComponent(location.href),
                            plat: 'napp',
                        },
                    },
                    downloads,
                    kind: 'share52202',
                    wxLaunchType,
                    wxLaunchSwitch,
                },
                {
                    clickCount: {
                        behavior: 'action',
                        type: 'downopen',
                        other: {
                            ref: `ucms_${content.base62Id}`,
                            kind: 'article',
                            url: encodeURIComponent(location.href),
                            plat: 'napp',
                        },
                    },
                    downloads,
                    kind: 'share52202',
                    wxLaunchType,
                    wxLaunchSwitch,
                },
            ],
        };

        if (config && config.slideSwitch === '1') {
            slidesConfig.isLogoPic = false;
            slidesConfig.lastSlideData = {
                id: config.gotoUrl || '',
                type: 'web',
                newstype: 'web',
                thumbnailpic: config.picUrl || '',
                share: config.gotoUrl || '',
                kind: 'share01',
                // noPrefixKind: true,
                dlUrl: config.gotoUrl || '',
                clickCount: {
                    behavior: 'action',
                    type: 'downopen',
                    other: {
                        ref: `ucms_${content.base62Id}`,
                        kind: 'article',
                        url: encodeURIComponent(location.href),
                        plat: 'napp',
                    },
                },
                downloads,
                wxLaunchType,
                wxLaunchSwitch,
            };
        }
        const schemeUrl = (pageBottomPic?.articleShare?.jumpMode === 2 && pageBottomPic?.articleShare?.url) || '';
        const schemeLink = schemeUrl
            ? getSchemeLink({
                  docType: 'custom',
                  pid: schemeUrl,
              })
            : '';

        return (
            <React.Fragment>
                {this.isOpenOperateHandle() ? (
                    <div className={styles.activityBox}>
                        <section className={styles.bottomSlide} onClick={this.activityHandle}>
                            <img className={styles.activityImage} src={pageBottomPic?.articleShare?.imageUrl} />
                            {wxLaunchSwitch && schemeUrl && !content.isVideoShare && (
                                <WxLaunchApp
                                    launchType="app"
                                    launchAppClick={this.activityHandle.bind(this, true, false, false)}
                                    schemeLink={schemeLink}
                                    launchAppFail={this.activityHandle.bind(this, false, true, true)}
                                />
                            )}
                        </section>
                    </div>
                ) : (
                    <section className={styles.bottomSlide} onClick={this.clickBottomHandle}>
                        <UpgradeBottomSlides noCloseIcon={true} content={slidesConfig} ad={ad} />
                    </section>
                )}
            </React.Fragment>
        );
    }
}

export default errorBoundary(BottomSlide);
